import type { AmpsTask } from "@/hooks/queries/amps-task-types";

/**
 * "{code} - {name}" task label via the catalogue join (6.4 idiom); code-only
 * fallback while the catalogue read is pending/failed. Shared by the Story 8.8
 * calibration screens (case log + completion) so the label format can't drift.
 */
export function taskLabel(tasks: AmpsTask[] | undefined, taskCode: string): string {
  const task = tasks?.find((t) => t.code === taskCode);
  return task ? `${task.code} - ${task.name}` : taskCode;
}
